{
  "models": [
    {
      "provider": "coreweave",
      "id": "cw_openai_gpt-oss-120b",
      "idPlayground": "openai/gpt-oss-120b",
      "idHuggingFace": "openai/gpt-oss-120b",
      "openRouterPermaslug": "openai/gpt-oss-120b",
      "label": "OpenAI GPT OSS 120B",
      "labelOpenRouter": "OpenAI: gpt-oss-120b",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "Efficient Mixture-of-Experts model designed for high-reasoning, agentic and general-purpose use cases.",
      "descriptionMedium": "GPT OSS 120B is an open-weight, 117B-parameter Mixture-of-Experts (MoE) language model from OpenAI designed for high-reasoning, agentic, and general-purpose production use cases. It activates 5.1B parameters per forward pass. The model supports configurable reasoning depth, full chain-of-thought access, and structured output generation.",
      "launchDate": "2025-08-05T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "reasoningEfforts": [
        "low",
        "medium",
        "high"
      ],
      "maximumLoRArank": 64,
      "parameterCountTotal": 117000000000,
      "parameterCountActive": 5100000000,
      "contextWindow": 131072,
      "priceCentsPerBillionTokensInput": 3000,
      "priceCentsPerBillionTokensCached": 3000,
      "priceCentsPerBillionTokensOutput": 17000,
      "quantization": "fp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 5487,
      "downloadsHuggingFace": 2479052,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_openai_gpt-oss-20b",
      "idPlayground": "openai/gpt-oss-20b",
      "idHuggingFace": "openai/gpt-oss-20b",
      "openRouterPermaslug": "openai/gpt-oss-20b",
      "label": "OpenAI GPT OSS 20B",
      "labelOpenRouter": "OpenAI: gpt-oss-20b",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "Lower latency Mixture-of-Experts model trained on OpenAI's Harmony response format with reasoning capabilities.",
      "descriptionMedium": "GPT OSS 20B is an open-weight 21B parameter model released by OpenAI. It uses a Mixture-of-Experts (MoE) architecture with 3.6B active parameters per forward pass, optimized for lower-latency inference. The model is trained in OpenAI\u2019s Harmony response format and supports reasoning level configuration and structured outputs.",
      "launchDate": "2025-08-05T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "reasoningEfforts": [
        "low",
        "medium",
        "high"
      ],
      "parameterCountTotal": 20000000000,
      "parameterCountActive": 3600000000,
      "contextWindow": 131072,
      "priceCentsPerBillionTokensInput": 3000,
      "priceCentsPerBillionTokensCached": 3000,
      "priceCentsPerBillionTokensOutput": 13000,
      "quantization": "fp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 5266,
      "downloadsHuggingFace": 5957662,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_google_gemma-4-31B-it",
      "idPlayground": "google/gemma-4-31B-it",
      "idHuggingFace": "google/gemma-4-31B-it",
      "openRouterPermaslug": "google/gemma-4-31b-it-20260402",
      "label": "Google Gemma 4 31B",
      "labelOpenRouter": "Google: Gemma 4 31B",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Gemma 4 31B Dense is designed for advanced reasoning, agentic workflows, and longer context and is natively trained on 140+ languages.",
      "descriptionMedium": "Gemma 4 31B Dense is the strongest Gemma 4 model best for advanced reasoning, agentic workflows, code generation, vision, and longer context and is natively trained on 140+ languages.",
      "launchDate": "2026-04-02T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-off",
      "reasoningEfforts": [
        "none",
        "low",
        "medium",
        "high"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 31000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 10000,
      "priceCentsPerBillionTokensCached": 10000,
      "priceCentsPerBillionTokensOutput": 34000,
      "quantization": "fp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 4282,
      "downloadsHuggingFace": 8012782,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_google_gemma-4-26B-A4B-it",
      "idPlayground": "google/gemma-4-26B-A4B-it",
      "idHuggingFace": "google/gemma-4-26B-A4B-it",
      "openRouterPermaslug": "google/gemma-4-26b-a4b-it-20260403",
      "label": "Google Gemma 4 26B A4B Instruct",
      "labelOpenRouter": "Google: Gemma 4 26B A4B",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "Gemma 4 26B A4B is a multimodal MoE model with LoRA support and function calling for agentic workflows.",
      "descriptionMedium": "Gemma 4 26B A4B is an instruction-tuned multimodal model from Google with LoRA support for task-specific customization. It handles text and image inputs and supports function calling for agentic workflows.",
      "launchDate": "2026-04-02T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": true,
      "reasoningSupport": "default-off",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "maximumLoRArank": 16,
      "parameterCountTotal": 26000000000,
      "parameterCountActive": 4000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 10000,
      "priceCentsPerBillionTokensCached": 5000,
      "priceCentsPerBillionTokensOutput": 30000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 1733,
      "downloadsHuggingFace": 5871104,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_ibm-granite_granite-4.2-8b",
      "idPlayground": "ibm-granite/granite-4.2-8b",
      "idHuggingFace": "ibm-granite/granite-4.2-8b",
      "openRouterPermaslug": "ibm-granite/granite-4.2-8b-20260831",
      "label": "IBM Granite 4.2 8B",
      "labelOpenRouter": "IBM: Granite 4.2 8B",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "Granite 4.2 8B is an instruct model capable of enhanced tool calling, instruction following, and chat capabilities.",
      "descriptionMedium": "Granite 4.2 8B is a performant instruct model for its size capable of enhanced tool calling, instruction following, and chat capabilities.",
      "launchDate": "2026-08-25T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "parameterCountTotal": 8000000000,
      "contextWindow": 131072,
      "priceCentsPerBillionTokensInput": 6000,
      "priceCentsPerBillionTokensCached": 1500,
      "priceCentsPerBillionTokensOutput": 15000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 112,
      "downloadsHuggingFace": 71150,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_ibm-granite_granite-4.1-8b",
      "idPlayground": "ibm-granite/granite-4.1-8b",
      "idHuggingFace": "ibm-granite/granite-4.1-8b",
      "openRouterPermaslug": "ibm-granite/granite-4.1-8b-20260429",
      "label": "IBM Granite 4.1 8B",
      "labelOpenRouter": "IBM: Granite 4.1 8B",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Granite 4.1 8B is a long-context instruct model capable of enhanced tool calling, instruction following, and chat capabilities.",
      "descriptionMedium": "Granite 4.1 8B is a long-context instruct model finetuned with an enhanced post-training pipeline resulting in enhanced tool calling, instruction following, and chat capabilities.",
      "launchDate": "2026-04-29T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 8000000000,
      "contextWindow": 131072,
      "priceCentsPerBillionTokensInput": 5000,
      "priceCentsPerBillionTokensCached": 5000,
      "priceCentsPerBillionTokensOutput": 10000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_ibm-granite_granite-4.2-8b"],
      "likesHuggingFace": 257,
      "downloadsHuggingFace": 95264,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_JetBrains_Mellum2-12B-A2.5B-Instruct",
      "idPlayground": "JetBrains/Mellum2-12B-A2.5B-Instruct",
      "idHuggingFace": "JetBrains/Mellum2-12B-A2.5B-Instruct",
      "label": "JetBrains Mellum2 12B A2.5B",
      "labelOpenRouter": "JetBrains: Mellum2 12B A2.5B",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Mellum2-12B-A2.5B-Instruct is a fast MoE model with 131K context built for coding, tool use, and low-latency AI workflows.",
      "descriptionMedium": "Mellum2-12B-A2.5B-Instruct is a JetBrains-built MoE model with 12B total parameters and only 2.5B active per token, supporting a 131K context window. Trained from scratch on natural language and code, it is designed as a fast, cost-efficient model for production AI systems \u2014 excelling at routing, Q&A, tool use, sub-agent tasks, and RAG pipelines where latency and throughput matter most.",
      "launchDate": "2026-06-01T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "structuredOutputBackend": "guidance",
      "parameterCountTotal": 12000000000,
      "parameterCountActive": 2500000000,
      "contextWindow": 131072,
      "priceCentsPerBillionTokensInput": 5000,
      "priceCentsPerBillionTokensCached": 5000,
      "priceCentsPerBillionTokensOutput": 10000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_ibm-granite_granite-4.2-8b"],
      "likesHuggingFace": 91,
      "downloadsHuggingFace": 11202,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_MiniMaxAI_MiniMax-M3",
      "idPlayground": "MiniMaxAI/MiniMax-M3",
      "idHuggingFace": "MiniMaxAI/MiniMax-M3",
      "openRouterPermaslug": "minimax/minimax-m3-20260531",
      "idLineage": ["MiniMaxAI/MiniMax-M3", "nvidia/MiniMax-M3-NVFP4"],
      "label": "MiniMax M3",
      "labelOpenRouter": "MiniMax: MiniMax M3",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "MiniMax M3 is a multimodal MoE model with 23B active parameters optimized for coding and agentic workflows.",
      "descriptionMedium": "MiniMax M3 is a multimodal MoE model featuring 23B activated parameters and a total of 428B parameters. It accepts text and image inputs and is optimized for long-horizon coding tasks and agentic and tool-use workflows.\n\nPlease refer to the MiniMax M3 License for terms of use. Use of MiniMax M3 or any derivatives prohibits the following:\n(1) generating or disseminating content prohibited by applicable laws or regulations;\n(2) assisting with or supporting any military purpose;\n(3) exploiting or harming minors;\n(4) generating or disseminating false or misleading information with intent to cause harm;\n(5) promoting discrimination, hate speech, or harmful behavior against protected groups.",
      "launchDate": "2026-06-12T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "structuredOutputBackend": "guidance",
      "reasoningSupport": "adaptive",
      "reasoningEfforts": [
        "low",
        "medium",
        "high"
      ],
      "reasoningArgument": "thinking_mode",
      "parameterCountTotal": 428000000000,
      "parameterCountActive": 23000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 23000,
      "priceCentsPerBillionTokensCached": 5000,
      "priceCentsPerBillionTokensOutput": 96000,
      "quantization": "fp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 1601,
      "downloadsHuggingFace": 183944,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_MiniMaxAI_MiniMax-M2.5",
      "idPlayground": "MiniMaxAI/MiniMax-M2.5",
      "idHuggingFace": "MiniMaxAI/MiniMax-M2.5",
      "openRouterPermaslug": "minimax/minimax-m2.5-20260211",
      "label": "MiniMax M2.5",
      "labelOpenRouter": "MiniMax: MiniMax M2.5",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-08-04T09:00:00Z",
      "dateRetired": "2026-08-25T09:00:00Z",
      "recommendedReplacement": ["cw_MiniMaxAI_MiniMax-M3"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q1 2026",
      "descriptionShort": "MoE model with a highly sparse architecture designed for high-throughput and low latency with strong coding capabilities.",
      "descriptionMedium": "MiniMax M2.5 is a Mixture-of-Experts (MoE) model featuring 230 billion total parameters and 10 billion active parameters per token during inference. This highly sparse architecture allows for high-throughput and low-latency with strong coding capabilities.",
      "launchDate": "2026-02-12T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "structuredOutputBackend": "guidance",
      "reasoningSupport": "always-on",
      "reasoningEfforts": [
        "low",
        "medium",
        "high"
      ],
      "parameterCountTotal": 230000000000,
      "parameterCountActive": 10000000000,
      "contextWindow": 196608,
      "priceCentsPerBillionTokensInput": 30000,
      "priceCentsPerBillionTokensCached": 30000,
      "priceCentsPerBillionTokensOutput": 120000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 1529,
      "downloadsHuggingFace": 1300753,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_zai-org_GLM-5.3",
      "idPlayground": "zai-org/GLM-5.3",
      "idHuggingFace": "zai-org/GLM-5.3",
      "openRouterPermaslug": "z-ai/glm-5.3-20260816",
      "label": "Z.AI GLM 5.3",
      "labelOpenRouter": "Z.ai: GLM 5.3",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q4 2026",
      "descriptionShort": "GLM-5.3 is a 744B-parameter MoE model built for advanced reasoning, software engineering, and long-horizon agentic tasks.",
      "descriptionMedium": "GLM-5.3 is a 744B-parameter Mixture-of-Experts model with 40B active parameters and a 1M-token context window. It excels in advanced reasoning, software engineering, and long-horizon agentic tasks, with support for tool calling and structured outputs.",
      "launchDate": "2026-08-14T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "reasoningEfforts": [
        "low",
        "high",
        "max"
      ],
      "parameterCountTotal": 744000000000,
      "parameterCountActive": 40000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 75000,
      "priceCentsPerBillionTokensCached": 19000,
      "priceCentsPerBillionTokensOutput": 300000,
      "quantization": "nvfp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 2375,
      "downloadsHuggingFace": 2356195,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_zai-org_GLM-5.3-Flash",
      "idPlayground": "zai-org/GLM-5.3-Flash",
      "idHuggingFace": "zai-org/GLM-5.3-Flash",
      "openRouterPermaslug": "z-ai/glm-5.3-flash-20260826",
      "label": "Z.AI GLM 5.3 Flash",
      "labelOpenRouter": "Z.ai: GLM 5.3 Flash",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "GLM-5.3-Flash is a natively multimodal model with 320B total parameters and 18B active parameters.",
      "descriptionMedium": "GLM-5.3-Flash is a natively multimodal model with 320B total parameters and 18B active parameters excelling in agentic tasks, coding, and tool use.",
      "launchDate": "2026-08-26T09:00:00.000Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "reasoningEfforts": [
        "low",
        "high",
        "max"
      ],
      "parameterCountTotal": 320000000000,
      "parameterCountActive": 18000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 12000,
      "priceCentsPerBillionTokensCached": 2000,
      "priceCentsPerBillionTokensOutput": 38000,
      "quantization": "nvfp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 3039,
      "downloadsHuggingFace": 6316631,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_zai-org_GLM-5.2",
      "idPlayground": "zai-org/GLM-5.2",
      "idHuggingFace": "zai-org/GLM-5.2",
      "openRouterPermaslug": "z-ai/glm-5.2-20260616",
      "label": "Z.AI GLM 5.2",
      "labelOpenRouter": "Z.AI: GLM 5.2",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "GLM-5.2 is a Mixture-of-Experts language model featuring 40 billion activated parameters and a total of 744 billion parameters.",
      "descriptionMedium": "GLM-5.2 is a Mixture-of-Experts language model featuring 40 billion activated parameters and a total of 744 billion parameters with a 1 million token context window. It is optimized for long-horizon agentic coding and software engineering tasks, achieving strong results among a variety of leading coding benchmarks. We serve a CoreWeave-optimized version of this model that has achieved comparable scores on Terminal-Bench 2.0.",
      "launchDate": "2026-06-16T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "structuredOutputBackend": "auto",
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 744000000000,
      "parameterCountActive": 40000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 62000,
      "priceCentsPerBillionTokensCached": 14000,
      "priceCentsPerBillionTokensOutput": 242000,
      "quantization": "fp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": ["gating"],
      "likesHuggingFace": 5199,
      "downloadsHuggingFace": 318820,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_zai-org_GLM-5.1",
      "idPlayground": "zai-org/GLM-5.1",
      "idHuggingFace": "zai-org/GLM-5.1-FP8",
      "openRouterPermaslug": "z-ai/glm-5.1-20260406",
      "label": "Z.AI GLM 5.1",
      "labelOpenRouter": "Z.AI: GLM 5.1",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-08-04T09:00:00Z",
      "dateRetired": "2026-08-25T09:00:00Z",
      "recommendedReplacement": ["cw_zai-org_GLM-5.2"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Powerful MoE model for long-horizon agentic engineering and advanced reasoning.",
      "descriptionMedium": "GLM-5.1 is a Mixture-of-Experts (MoE) model for long-horizon agentic engineering and advanced reasoning. It delivers significant improvement compared to GLM-5 across a wide range of academic benchmarks.",
      "launchDate": "2026-04-07T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "structuredOutputBackend": "xgrammar",
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 744000000000,
      "parameterCountActive": 40000000000,
      "contextWindow": 202752,
      "priceCentsPerBillionTokensInput": 140000,
      "priceCentsPerBillionTokensCached": 26000,
      "priceCentsPerBillionTokensOutput": 440000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 122,
      "downloadsHuggingFace": 19556,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_zai-org_GLM-5-FP8",
      "idPlayground": "zai-org/GLM-5-FP8",
      "idHuggingFace": "zai-org/GLM-5-FP8",
      "label": "Z.AI GLM 5",
      "labelOpenRouter": "Z.AI: GLM 5",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-04-24T09:00:00Z",
      "dateRetired": "2026-05-11T09:00:00Z",
      "recommendedReplacement": ["cw_zai-org_GLM-5.1"],
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q1 2026",
      "descriptionShort": "Mixture-of-Experts model for long-horizon agentic tasks with strong performance on reasoning and coding.",
      "descriptionMedium": "GLM-5 is a Mixture-of-Experts (MoE) model for long-horizon agentic tasks. It delivers significant improvement compared to GLM-4.7 across a wide range of academic benchmarks with strong performance across reasoning, coding, and agentic tasks.",
      "launchDate": "2026-02-11T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 744000000000,
      "parameterCountActive": 40000000000,
      "contextWindow": 200000,
      "priceCentsPerBillionTokensInput": 100000,
      "priceCentsPerBillionTokensCached": 100000,
      "priceCentsPerBillionTokensOutput": 320000,
      "quantization": "fp8",
      "isAvailableOpenRouter": false,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 184,
      "downloadsHuggingFace": 39321,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_zai-org_GLM-4.5",
      "idPlayground": "zai-org/GLM-4.5",
      "idHuggingFace": "zai-org/GLM-4.5",
      "label": "Z.AI GLM 4.5",
      "labelOpenRouter": "Z.AI: GLM 4.5",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-02-12T09:00:00Z",
      "dateRetired": "2026-03-04T09:00:00Z",
      "recommendedReplacement": ["cw_zai-org_GLM-5-FP8"],
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "Mixture-of-Experts model with user-controllable thinking/non-thinking modes for strong reasoning, code generation, and agent alignment.",
      "descriptionMedium": "GLM-4.5 is purpose built for agent-based applications. It leverages a Mixture-of-Experts (MoE) architecture and delivers significantly enhanced capabilities in reasoning, code generation, and agent alignment. It supports a hybrid inference mode with two options, a \"thinking mode\" designed for complex reasoning and tool use, and a \"non-thinking mode\" optimized for instant responses. Users can control the reasoning behavior with the reasoning enabled boolean.",
      "launchDate": "2025-09-05T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 355000000000,
      "parameterCountActive": 32000000000,
      "contextWindow": 131000,
      "priceCentsPerBillionTokensInput": 55000,
      "priceCentsPerBillionTokensCached": 55000,
      "priceCentsPerBillionTokensOutput": 200000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 1439,
      "downloadsHuggingFace": 108498,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_nvidia_Nemotron-3.5-Super-VL-120B-A12B",
      "idPlayground": "nvidia/NVIDIA-Nemotron-3.5-Super-VL-120B-A12B",
      "idHuggingFace": "nvidia/NVIDIA-Nemotron-3.5-Super-VL-120B-A12B-NVFP4",
      "openRouterPermaslug": "nvidia/nemotron-3.5-super-vl-20261015",
      "label": "NVIDIA Nemotron 3.5 Super VL",
      "labelOpenRouter": "NVIDIA: Nemotron 3.5 Super VL",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q4 2026",
      "descriptionShort": "Nemotron 3.5 Super VL is a multimodal MoE model built for visual understanding, reasoning, and agentic workflows.",
      "descriptionMedium": "Nemotron 3.5 Super VL is a multimodal Mixture-of-Experts model with 120B total parameters and 12B active parameters, supporting text and image inputs. It is built for visual understanding, reasoning, and agentic workflows, with a 1M-token context, tool calling, and structured outputs.",
      "launchDate": "2026-10-15T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "structuredOutputBackend": "auto",
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 120000000000,
      "parameterCountActive": 12000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 15000,
      "priceCentsPerBillionTokensCached": 2000,
      "priceCentsPerBillionTokensOutput": 50000,
      "quantization": "nvfp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 260,
      "downloadsHuggingFace": 32882,
      "license": "other",
      "isNew": true
    },
    {
      "provider": "coreweave",
      "id": "cw_nvidia_Nemotron-3.5-Lightning-30B-A3B",
      "idPlayground": "nvidia/NVIDIA-Nemotron-3.5-Lightning-30B-A3B",
      "idHuggingFace": "nvidia/NVIDIA-Nemotron-3.5-Lightning-30B-A3B-BF16",
      "openRouterPermaslug": "nvidia/nemotron-3.5-lightning-20260807",
      "label": "NVIDIA Nemotron 3.5 Lightning",
      "labelOpenRouter": "NVIDIA: Nemotron 3.5 Lightning",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "Nemotron 3.5 Lightning is an MoE model built for fast, reliable agentic tasks across use cases such as financial services, cybersecurity, telecom, and retail.",
      "descriptionMedium": "Nemotron 3.5 Lightning is an MoE model built for fast, reliable agentic tasks across use cases such as financial services, cybersecurity, telecom, and retail.",
      "launchDate": "2026-08-11T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": true,
      "structuredOutputBackend": "guidance",
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "maximumLoRArank": 16,
      "parameterCountTotal": 30000000000,
      "parameterCountActive": 3000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 7000,
      "priceCentsPerBillionTokensCached": 4000,
      "priceCentsPerBillionTokensOutput": 20000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 266,
      "downloadsHuggingFace": 1136444,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_nvidia_Nemotron-3-Ultra-550B-A55B",
      "idPlayground": "nvidia/NVIDIA-Nemotron-3-Ultra-550B-A55B",
      "idHuggingFace": "nvidia/NVIDIA-Nemotron-3-Ultra-550B-A55B-BF16",
      "openRouterPermaslug": "nvidia/nemotron-3-ultra-550b-a55b-20260604",
      "label": "NVIDIA Nemotron 3 Ultra",
      "labelOpenRouter": "NVIDIA: Nemotron 3 Ultra",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Nemotron 3 Ultra is a powerful MoE model designed for long-running agents across coding, deep research, and enterprise automation.",
      "descriptionMedium": "Nemotron 3 Ultra is a powerful MoE model designed by NVIDIA for long-running agents across coding, deep research, and enterprise automation. Built for efficiency, Nemotron 3 Ultra is ideal for deploying agentic workflows at scale.",
      "launchDate": "2026-06-04T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "structuredOutputBackend": "guidance",
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 550000000000,
      "parameterCountActive": 55000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 50000,
      "priceCentsPerBillionTokensCached": 10000,
      "priceCentsPerBillionTokensOutput": 215000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 381,
      "downloadsHuggingFace": 1351170,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_nvidia_Nemotron-3-Super-120B-A12B",
      "idPlayground": "nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-FP8",
      "idHuggingFace": "nvidia/NVIDIA-Nemotron-3-Super-120B-A12B-FP8",
      "openRouterPermaslug": "nvidia/nemotron-3-super-120b-a12b-20230311",
      "label": "NVIDIA Nemotron 3 Super 120B",
      "labelOpenRouter": "NVIDIA: Nemotron 3 Super",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-08-04T09:00:00Z",
      "dateRetired": "2026-08-25T09:00:00Z",
      "recommendedReplacement": ["cw_nvidia_Nemotron-3-Ultra-550B-A55B"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q1 2026",
      "descriptionShort": "Nemotron 3 is a LatentMoE model designed to deliver strong agentic, reasoning, and conversational capabilities.",
      "descriptionMedium": "Nemotron 3 is a LatentMoE model designed to deliver strong agentic, reasoning, and conversational capabilities. It is optimized for high-volume workloads such as IT ticket automation.",
      "launchDate": "2026-03-11T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "low",
        "medium",
        "high"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 120000000000,
      "parameterCountActive": 12000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 20000,
      "priceCentsPerBillionTokensCached": 20000,
      "priceCentsPerBillionTokensOutput": 80000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 293,
      "downloadsHuggingFace": 50132,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3.8-27B",
      "idPlayground": "Qwen/Qwen3.8-27B",
      "idHuggingFace": "Qwen/Qwen3.8-27B",
      "idLineage": ["Qwen/Qwen3.8-27B", "Qwen/Qwen3.8-27B-FP8"],
      "openRouterPermaslug": "qwen/qwen3.8-27b-20260814",
      "label": "Qwen3.8 27B",
      "labelOpenRouter": "Qwen: Qwen3.8 27B",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "Qwen3.8-27B is a dense multimodal model suited for coding, research, vision, and long-running agent tasks.",
      "descriptionMedium": "Qwen3.8-27B is a dense multimodal model suited for coding, research, vision, and long-running agent tasks with broad support for popular harnesses and development tools.",
      "launchDate": "2026-08-14T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": true,
      "structuredOutputBackend": "auto",
      "reasoningSupport": "default-on",
      "_reasoningEfforts": "Chat template only accepts xhigh (default), medium, and low. none maps to enable_thinking=false. Omit high/max/minimal \u2014 those 400.",
      "reasoningEfforts": [
        "none",
        "low",
        "medium",
        "xhigh"
      ],
      "reasoningArgument": "enable_thinking",
      "maximumLoRArank": 16,
      "parameterCountTotal": 27000000000,
      "parameterCountActive": 27000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 40000,
      "priceCentsPerBillionTokensCached": 15000,
      "priceCentsPerBillionTokensOutput": 300000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 19087,
      "downloadsHuggingFace": 8014877,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3.6-27B",
      "idPlayground": "Qwen/Qwen3.6-27B",
      "idHuggingFace": "Qwen/Qwen3.6-27B",
      "idLineage": ["Qwen/Qwen3.6-27B", "Qwen/Qwen3.6-27B-FP8"],
      "openRouterPermaslug": "qwen/qwen3.6-27b-20260422",
      "label": "Qwen3.6 27B",
      "labelOpenRouter": "Qwen: Qwen3.6 27B",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Qwen3.6-27B is a 27B dense multimodal model with 262K context built for flagship-level agentic coding.",
      "descriptionMedium": "Qwen3.6-27B is a 27B dense multimodal model with a 262K native context window. As the flagship of the Qwen3.6 family, it delivers top-tier performance in agentic coding, STEM reasoning, and vision-language tasks.",
      "launchDate": "2026-04-22T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": true,
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "maximumLoRArank": 16,
      "parameterCountTotal": 27000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 60000,
      "priceCentsPerBillionTokensCached": 12000,
      "priceCentsPerBillionTokensOutput": 360000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_Qwen_Qwen3.8-27B"],
      "likesHuggingFace": 2345,
      "downloadsHuggingFace": 2274606,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3.6-35B-A3B",
      "idPlayground": "Qwen/Qwen3.6-35B-A3B",
      "idHuggingFace": "Qwen/Qwen3.6-35B-A3B",
      "openRouterPermaslug": "qwen/qwen3.6-35b-a3b-20260415",
      "idLineage": ["Qwen/Qwen3.6-35B-A3B", "Qwen/Qwen3.6-35B-A3B-FP8"],
      "label": "Qwen3.6 35B A3B",
      "labelOpenRouter": "Qwen: Qwen3.6 35B A3B",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Qwen3.6-35B-A3B is an MoE multimodal model with 262K context optimized for agentic coding workflows.",
      "descriptionMedium": "Qwen3.6-35B-A3B is a 35B-parameter MoE multimodal model with 3B active parameters and a 262K native context window. As the MoE variant in the Qwen3.6 family, its architecture makes it ideal for efficient agentic coding and high-volume workflows.",
      "launchDate": "2026-04-15T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": true,
      "structuredOutputBackend": "auto",
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "maximumLoRArank": 16,
      "parameterCountTotal": 35000000000,
      "parameterCountActive": 3000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 10000,
      "priceCentsPerBillionTokensCached": 5000,
      "priceCentsPerBillionTokensOutput": 95000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 3074,
      "downloadsHuggingFace": 4530442,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3.5-27B",
      "idPlayground": "Qwen/Qwen3.5-27B",
      "idHuggingFace": "Qwen/Qwen3.5-27B",
      "idLineage": ["Qwen/Qwen3.5-27B", "Qwen/Qwen3.5-27B-FP8"],
      "openRouterPermaslug": "qwen/qwen3.5-27b-20260224",
      "label": "Qwen3.5 27B",
      "labelOpenRouter": "Qwen: Qwen3.5-27B",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-06-30T09:00:00Z",
      "dateRetired": "2026-08-04T09:00:00Z",
      "recommendedReplacement": ["cw_Qwen_Qwen3.6-27B"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Qwen3.5-27B is a dense model from the Qwen3.5 family built for high performance across a large range of benchmarks.",
      "descriptionMedium": "Qwen3.5-27B is a dense model from the Qwen3.5 family excelling at instruction following, long context, reasoning, and search.",
      "launchDate": "2026-02-24T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 27000000000,
      "parameterCountActive": 27000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 39000,
      "priceCentsPerBillionTokensCached": 8000,
      "priceCentsPerBillionTokensOutput": 312000,
      "quantization": "fp8",
      "isAvailableOpenRouter": false,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 1084,
      "downloadsHuggingFace": 1779903,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3.5-35B-A3B",
      "idPlayground": "Qwen/Qwen3.5-35B-A3B",
      "idHuggingFace": "Qwen/Qwen3.5-35B-A3B",
      "idLineage": ["Qwen/Qwen3.5-35B-A3B", "Qwen/Qwen3.5-35B-A3B-FP8"],
      "openRouterPermaslug": "qwen/qwen3.5-35b-a3b-20260224",
      "label": "Qwen3.5 35B A3B",
      "labelOpenRouter": "Qwen: Qwen3.5-35B-A3B",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q1 2026",
      "descriptionShort": "Qwen3.5-35B-A3B is an open-weights multimodal MoE model built for efficient, high-throughput inference across chat, reasoning, and agentic tasks.",
      "descriptionMedium": "Qwen3.5-35B-A3B is a multimodal mixture-of-experts model built for fast, efficient inference across chat, reasoning, coding, agents, and vision-language workloads. With 35B total parameters, 3B active parameters, a 262,144-token context window, and support for 201 languages and dialects, it\u2019s a strong choice for production applications that need long context and broad multimodal capability.",
      "launchDate": "2026-02-24T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 35000000000,
      "parameterCountActive": 3000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 25000,
      "priceCentsPerBillionTokensCached": 25000,
      "priceCentsPerBillionTokensOutput": 125000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_Qwen_Qwen3.6-35B-A3B"],
      "likesHuggingFace": 1550,
      "downloadsHuggingFace": 1682640,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_OpenPipe_Qwen3-14B-Instruct",
      "idPlayground": "OpenPipe/Qwen3-14B-Instruct",
      "idHuggingFace": "OpenPipe/Qwen3-14B-Instruct",
      "label": "OpenPipe Qwen3 14B Instruct",
      "labelOpenRouter": "OpenPipe: Qwen3 14B Instruct",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q4 2025",
      "descriptionShort": "An efficient multilingual, dense, instruction-tuned model, optimized by OpenPipe for building agents with finetuning.",
      "descriptionMedium": "OpenPipe/Qwen3-14B-Instruct is a finetune friendly instruct variant of Qwen3-14B. Qwen3 release does not include a 14B Instruct (non-thinking) model, this fork introduces an updated chat template that makes Qwen3-14B non-thinking by default and be highly compatible with OpenPipe and other finetuning frameworks. The default Qwen3 chat template does not render <think></think> tags on the previous assistant message, which can lead to inconsistencies between training and generation. This version resolves that issue by adding <think></think> tags to all assistant prompts and generation templates to ensure message format consistency during both training and inference. The model retains the strong general capabilities of Qwen3-14B while providing a more finetuning friendly chat template.",
      "launchDate": "2025-04-29T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": true,
      "maximumLoRArank": 16,
      "parameterCountTotal": 14800000000,
      "contextWindow": 32768,
      "priceCentsPerBillionTokensInput": 5000,
      "priceCentsPerBillionTokensCached": 5000,
      "priceCentsPerBillionTokensOutput": 22000,
      "quantization": "bf16",
      "isAvailableOpenRouter": false,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_Qwen_Qwen3.8-27B"],
      "likesHuggingFace": 15,
      "downloadsHuggingFace": 4021,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3-30B-A3B-Instruct-2507",
      "idPlayground": "Qwen/Qwen3-30B-A3B-Instruct-2507",
      "idHuggingFace": "Qwen/Qwen3-30B-A3B-Instruct-2507",
      "openRouterPermaslug": "qwen/qwen3-30b-a3b-instruct-2507",
      "label": "Qwen3 30B A3B",
      "labelOpenRouter": "Qwen: Qwen3 30B A3B Instruct 2507",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q1 2026",
      "descriptionShort": "Qwen3-30B-A3B-Instruct-2507 is a 30.5B MoE instruction-tuned model with enhanced reasoning, coding, and long-context understanding.",
      "descriptionMedium": "Qwen3-30B-A3B-Instruct-2507 is a 30.5B-parameter mixture-of-experts LLM by Qwen, optimized for instruction following in non-thinking mode with 3.3B active parameters per inference. It offers stronger general capabilities across reasoning, comprehension, coding, and tools, plus long-context support up to 262K tokens and improved multilingual performance.",
      "launchDate": "2025-07-29T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": true,
      "maximumLoRArank": 16,
      "parameterCountTotal": 30500000000,
      "parameterCountActive": 3300000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 10000,
      "priceCentsPerBillionTokensCached": 10000,
      "priceCentsPerBillionTokensOutput": 30000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_Qwen_Qwen3.6-35B-A3B"],
      "likesHuggingFace": 855,
      "downloadsHuggingFace": 1006002,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3-235B-A22B-Instruct-2507",
      "idPlayground": "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "idHuggingFace": "Qwen/Qwen3-235B-A22B-Instruct-2507",
      "openRouterPermaslug": "qwen/qwen3-235b-a22b-thinking-2507",
      "label": "Qwen3 235B A22B-2507",
      "labelOpenRouter": "Qwen: Qwen3 235B A22B-2507",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-06-30T09:00:00Z",
      "dateRetired": "2026-08-04T09:00:00Z",
      "recommendedReplacement": ["cw_Qwen_Qwen3.6-27B"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "Efficient multilingual, Mixture-of-Experts, instruction-tuned model, optimized for logical reasoning.",
      "descriptionMedium": "Qwen3-235B-A22B-Instruct-2507 is a multilingual, instruction-tuned mixture-of-experts language model based on the Qwen3-235B architecture, with 22B active parameters per forward pass. It is optimized for general-purpose text generation, including instruction following, logical reasoning, math, code, and tool usage. The model does not implement \"thinking mode\" (<think> blocks). Compared to its base variant, this version delivers significant gains in knowledge coverage, long-context reasoning, coding benchmarks, and alignment with open-ended tasks. It is particularly strong on multilingual understanding, math reasoning (e.g., AIME, HMMT), and alignment evaluations like Arena-Hard and WritingBench.",
      "launchDate": "2025-07-22T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 235000000000,
      "parameterCountActive": 22000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 10000,
      "priceCentsPerBillionTokensCached": 10000,
      "priceCentsPerBillionTokensOutput": 10000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 814,
      "downloadsHuggingFace": 96444,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3-Coder-480B-A35B-Instruct",
      "idPlayground": "Qwen/Qwen3-Coder-480B-A35B-Instruct",
      "idHuggingFace": "Qwen/Qwen3-Coder-480B-A35B-Instruct",
      "openRouterPermaslug": "qwen/qwen3-coder-480b-a35b-07-25",
      "label": "Qwen3 Coder 480B A35B",
      "labelOpenRouter": "Qwen: Qwen3 Coder 480B A35B",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-08-04T09:00:00Z",
      "dateRetired": "2026-08-25T09:00:00Z",
      "recommendedReplacement": ["cw_zai-org_GLM-5.2"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "Mixture-of-Experts model optimized for agentic coding tasks such as function calling, tool use, and long-context reasoning.",
      "descriptionMedium": "Qwen3-Coder-480B-A35B-Instruct is a Mixture-of-Experts (MoE) code generation model developed by the Qwen team. It is optimized for agentic coding tasks such as function calling, tool use, and long-context reasoning over repositories. The model features 480 billion total parameters, with 35 billion active per forward pass (8 out of 160 experts).",
      "launchDate": "2025-07-22T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 480000000000,
      "parameterCountActive": 35000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 100000,
      "priceCentsPerBillionTokensCached": 100000,
      "priceCentsPerBillionTokensOutput": 150000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 1386,
      "downloadsHuggingFace": 58422,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen3-235B-A22B-Thinking-2507",
      "idPlayground": "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "idHuggingFace": "Qwen/Qwen3-235B-A22B-Thinking-2507",
      "label": "Qwen3 235B A22B Thinking-2507",
      "labelOpenRouter": "Qwen: Qwen3 235B A22B Thinking-2507",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-06-30T09:00:00Z",
      "dateRetired": "2026-08-04T09:00:00Z",
      "recommendedReplacement": ["cw_Qwen_Qwen3.6-27B"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "High-performance Mixture-of-Experts model optimized for structured reasoning, math, and long-form generation.",
      "descriptionMedium": "Qwen3-235B-A22B-Thinking-2507 is a high-performance, open-weight Mixture-of-Experts (MoE) language model optimized for complex reasoning tasks. It activates 22B of its 235B parameters per forward pass. This \"thinking-only\" variant enhances structured logical reasoning, mathematics, science, and long-form generation, showing strong benchmark performance across AIME, SuperGPQA, LiveCodeBench, and MMLU-Redux. It enforces a special reasoning mode (</think>) and is designed for high-token outputs in challenging domains.\nThe model is instruction-tuned and excels at step-by-step reasoning, tool use, agentic workflows, and multilingual tasks. This release represents the most capable open-source variant in the Qwen3-235B series, surpassing many closed models in structured reasoning use cases as of July 2025.",
      "launchDate": "2025-07-25T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "reasoningEfforts": [
        "low",
        "medium",
        "high"
      ],
      "parameterCountTotal": 235000000000,
      "parameterCountActive": 22000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 10000,
      "priceCentsPerBillionTokensCached": 10000,
      "priceCentsPerBillionTokensOutput": 10000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 419,
      "downloadsHuggingFace": 10136,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_Qwen_Qwen2.5-14B-Instruct",
      "idPlayground": "Qwen/Qwen2.5-14B-Instruct",
      "idHuggingFace": "Qwen/Qwen2.5-14B-Instruct",
      "label": "Qwen2.5 14B Instruct",
      "labelOpenRouter": "Qwen: Qwen2.5 14B Instruct",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-02-05T09:00:00Z",
      "dateRetired": "2026-03-04T09:00:00Z",
      "recommendedReplacement": ["cw_OpenPipe_Qwen3-14B-Instruct"],
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "Dense multilingual instruction-tuned model with tool-use and structured output support.",
      "descriptionMedium": "Qwen2.5-14B is a dense 14.7B parameter causal language model from the Qwen2.5 series, released as part of a family of base and instruction-tuned models ranging from 0.5B to 72B parameters. It delivers significant improvements over Qwen2, including stronger performance in coding and mathematics through specialized expert models, better instruction following, enhanced handling of structured data and outputs such as JSON, and more robust adaptability to diverse system prompts for role-play and chatbot settings. The model natively offers multilingual support across 29+ languages, including Chinese, English, French, Spanish, Portuguese, German, Japanese, Korean, and Arabic. Qwen2.5-14B was trained with both pre-training and post-training for versatile instruction-tuned applications.",
      "launchDate": "2024-09-19T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": false,
      "maximumLoRArank": 16,
      "parameterCountTotal": 14700000000,
      "contextWindow": 32768,
      "priceCentsPerBillionTokensInput": 6000,
      "priceCentsPerBillionTokensCached": 6000,
      "priceCentsPerBillionTokensOutput": 24000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 380,
      "downloadsHuggingFace": 751724,
      "license": "apache-2.0"
    },
    {
      "provider": "coreweave",
      "id": "cw_reflection_Beam-1.0-501B-A23B",
      "idPlayground": "reflection/Beam-1.0-501B-A23B",
      "idHuggingFace": "reflection/Beam-1.0-501B-A23B-NVFP4",
      "openRouterPermaslug": "reflection/beam-1.0-501b-a23b-20261016",
      "label": "Reflection Beam 1.0",
      "labelOpenRouter": "Reflection: Beam 1.0 501B A23B",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q4 2026",
      "descriptionShort": "Beam is a 501B-parameter MoE model with 23B active parameters built for coding, reasoning, and agentic workflows.",
      "descriptionMedium": "Beam is a 501B-parameter Mixture-of-Experts model from Reflection with 23B active parameters and a 1M-token context window. Built for coding, reasoning, and agentic workflows, it supports tool calling and structured outputs.",
      "launchDate": "2026-10-16T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "reasoningEfforts": [
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "parameterCountTotal": 501000000000,
      "parameterCountActive": 23000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 30000,
      "priceCentsPerBillionTokensCached": 4000,
      "priceCentsPerBillionTokensOutput": 100000,
      "quantization": "nvfp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 42,
      "downloadsHuggingFace": 5453,
      "license": "apache-2.0",
      "isNew": true
    },
    {
      "provider": "coreweave",
      "id": "cw_moonshotai_Kimi-K3",
      "idPlayground": "moonshotai/Kimi-K3",
      "idHuggingFace": "moonshotai/Kimi-K3",
      "openRouterPermaslug": "moonshotai/kimi-k3-20260715",
      "label": "Moonshot AI Kimi K3",
      "labelOpenRouter": "Moonshot AI: Kimi K3",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": [],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "Kimi K3 is a 2.8T-parameter multimodal MoE model with 104B active parameters built for long-horizon coding and agentic workflows.",
      "descriptionMedium": "Kimi K3 is a 2.8T-parameter multimodal Mixture-of-Experts model with 104B active parameters. It accepts text and image inputs and is purpose-built for long-horizon coding and agentic workflows with particular strength in navigating large repositories, tool use, and frontend coding.",
      "launchDate": "2026-07-16T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "_reasoningEfforts": "Reasoning is enabled by default and can be disabled with 'none'",
      "reasoningEfforts": [
        "none",
        "low",
        "high",
        "max"
      ],
      "structuredOutputBackend": "xgrammar",
      "parameterCountTotal": 2800000000000,
      "parameterCountActive": 104000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 300000,
      "priceCentsPerBillionTokensCached": 30000,
      "priceCentsPerBillionTokensOutput": 1500000,
      "quantization": "int4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 11932,
      "downloadsHuggingFace": 779427,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_moonshotai_Kimi-K2.7-Code",
      "idPlayground": "moonshotai/Kimi-K2.7-Code",
      "idHuggingFace": "moonshotai/Kimi-K2.7-Code",
      "openRouterPermaslug": "moonshotai/kimi-k2.7-code-20260612",
      "label": "Moonshot AI Kimi K2.7 Code",
      "labelOpenRouter": "Moonshot AI: Kimi K2.7 Code",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Kimi K2.7 Code is a 1T-parameter MoE model with 32B active parameters purpose-built for long-horizon agentic coding and software engineering.",
      "descriptionMedium": "Kimi K2.7 Code is a 1T-parameter MoE model with 32B active parameters and a 262k context window. Built on Kimi K2.6, it is purpose-built for complex, real-world software engineering workflows, delivering strong end-to-end task completion on long-horizon agentic coding tasks while cutting thinking-token usage by ~30% over its predecessor.",
      "launchDate": "2026-06-12T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "_reasoningEfforts": "Model will accept 'none' effort but ignores it, so we omit below",
      "reasoningEfforts": [
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "structuredOutputBackend": "xgrammar",
      "parameterCountTotal": 1000000000000,
      "parameterCountActive": 32000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 60000,
      "priceCentsPerBillionTokensCached": 12000,
      "priceCentsPerBillionTokensOutput": 300000,
      "quantization": "int4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 1428,
      "downloadsHuggingFace": 79446,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_moonshotai_Kimi-K2.6",
      "idPlayground": "moonshotai/Kimi-K2.6",
      "idHuggingFace": "moonshotai/Kimi-K2.6",
      "openRouterPermaslug": "moonshotai/kimi-k2.6-20260420",
      "label": "Moonshot AI Kimi K2.6",
      "labelOpenRouter": "Moonshot AI: Kimi K2.6",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "Kimi K2.6 is a multimodal Mixture-of-Experts language model featuring 32 billion activated parameters and a total of 1 trillion parameters.",
      "descriptionMedium": "Kimi K2.6 is a multimodal Mixture-of-Experts language model featuring 32 billion activated parameters and a total of 1 trillion parameters optimized for large-scale agentic and coding tasks. We serve an optimized version of this model that has achieved comparable scores on Terminal-Bench 2.0.",
      "launchDate": "2026-04-20T00:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "_reasoningEfforts": "Model will accept 'none' effort but ignores it, so we omit below",
      "reasoningEfforts": [
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "structuredOutputBackend": "xgrammar",
      "parameterCountTotal": 1000000000000,
      "parameterCountActive": 32000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 65000,
      "priceCentsPerBillionTokensCached": 15000,
      "priceCentsPerBillionTokensOutput": 341000,
      "quantization": "fp4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": ["gating"],
      "likesHuggingFace": 1640,
      "downloadsHuggingFace": 246985,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_moonshotai_Kimi-K2.5",
      "idPlayground": "moonshotai/Kimi-K2.5",
      "idHuggingFace": "nvidia/Kimi-K2.5-NVFP4",
      "openRouterPermaslug": "moonshotai/kimi-k2.5-0127",
      "idLineage": ["moonshotai/Kimi-K2.5", "nvidia/Kimi-K2.5-NVFP4"],
      "label": "Moonshot AI Kimi K2.5",
      "labelOpenRouter": "Moonshot AI: Kimi K2.5",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-06-30T09:00:00Z",
      "dateRetired": "2026-08-04T09:00:00Z",
      "recommendedReplacement": ["cw_moonshotai_Kimi-K2.6", "cw_moonshotai_Kimi-K2.7-Code"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q1 2026",
      "descriptionShort": "Kimi K2.5 is a multimodal Mixture-of-Experts language model featuring 32 billion activated parameters and a total of 1 trillion parameters.",
      "descriptionMedium": "Kimi K2.5 is a multimodal Mixture-of-Experts language model featuring 32 billion activated parameters and a total of 1 trillion parameters. It has been optimized for agentic use cases and excels at reasoning and coding tasks. We serve NVIDIA's Blackwell-optimized model.",
      "launchDate": "2026-02-02T00:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "always-on",
      "_reasoningEfforts": "Model will accept 'none' effort but ignores it, so we omit below",
      "reasoningEfforts": [
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "structuredOutputBackend": "xgrammar",
      "parameterCountTotal": 1000000000000,
      "parameterCountActive": 32000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 60000,
      "priceCentsPerBillionTokensCached": 10000,
      "priceCentsPerBillionTokensOutput": 300000,
      "priceHistory": [
        {
          "date": "2026-04-01T00:00:00Z",
          "wasPriceCentsPerBillionTokensInput": 50000,
          "wasPriceCentsPerBillionTokensCached": 50000,
          "wasPriceCentsPerBillionTokensOutput": 285000
        }
      ],
      "quantization": "int4",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 2898,
      "downloadsHuggingFace": 404338,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_moonshotai_Kimi-K2-Instruct-0905",
      "idPlayground": "moonshotai/Kimi-K2-Instruct-0905",
      "idHuggingFace": "moonshotai/Kimi-K2-Instruct-0905",
      "label": "Moonshot AI Kimi K2 Instruct 0905",
      "labelOpenRouter": "Moonshot AI: Kimi K2 Instruct 0905",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-02-12T09:00:00Z",
      "dateRetired": "2026-03-04T09:00:00Z",
      "recommendedReplacement": ["cw_moonshotai_Kimi-K2.5"],
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q4 2025",
      "descriptionShort": "Latest version of Kimi K2 mixture-of-experts language model, featuring 32 billion activated parameters and a total of 1 trillion parameters.",
      "descriptionMedium": "Kimi K2-Instruct-0905 is the latest, most capable version of Kimi K2. It is a state-of-the-art mixture-of-experts (MoE) language model, featuring 32 billion activated parameters and a total of 1 trillion parameters. Key Features 1/ Enhanced agentic coding intelligence: Kimi K2-Instruct-0905 demonstrates significant improvements in performance on public benchmarks and real-world coding agent tasks. 2/ Improved frontend coding experience: Kimi K2-Instruct-0905 offers advancements in both the aesthetics and practicality of frontend programming. 3/ Extended context length: Kimi K2-Instruct-0905\u2019s context window has been increased from 128k to 256k tokens, providing better support for long-horizon tasks.",
      "launchDate": "2025-09-05T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 1000000000000,
      "parameterCountActive": 32000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 60000,
      "priceCentsPerBillionTokensCached": 60000,
      "priceCentsPerBillionTokensOutput": 250000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 790,
      "downloadsHuggingFace": 11792,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_moonshotai_Kimi-K2-Instruct",
      "idPlayground": "moonshotai/Kimi-K2-Instruct",
      "idHuggingFace": "moonshotai/Kimi-K2-Instruct",
      "label": "Moonshot AI Kimi K2",
      "labelOpenRouter": "Moonshot AI: Kimi K2",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-02-12T09:00:00Z",
      "dateRetired": "2026-03-04T09:00:00Z",
      "recommendedReplacement": ["cw_moonshotai_Kimi-K2.5"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "Mixture-of-Experts model optimized for complex tool use, reasoning, and code synthesis.",
      "descriptionMedium": "Kimi K2 is a large-scale Mixture-of-Experts (MoE) language model developed by Moonshot AI, featuring 1 trillion total parameters with 32 billion active per forward pass. It is optimized for agentic capabilities, including advanced tool use, reasoning, and code synthesis. Kimi K2 excels across a broad range of benchmarks, particularly in coding (LiveCodeBench, SWE-bench), reasoning (ZebraLogic, GPQA), and tool-use (Tau2, AceBench) tasks. It supports long-context inference up to 128K tokens and is designed with a novel training stack that includes the MuonClip optimizer for stable large-scale MoE training.",
      "launchDate": "2025-07-14T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 1000000000000,
      "parameterCountActive": 32000000000,
      "contextWindow": 131000,
      "priceCentsPerBillionTokensInput": 135000,
      "priceCentsPerBillionTokensCached": 135000,
      "priceCentsPerBillionTokensOutput": 400000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 3008,
      "downloadsHuggingFace": 311373,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_meta-llama_Llama-3.1-70B-Instruct",
      "idPlayground": "meta-llama/Llama-3.1-70B-Instruct",
      "idHuggingFace": "meta-llama/Llama-3.1-70B-Instruct",
      "openRouterPermaslug": "meta-llama/llama-3.1-70b-instruct",
      "label": "Meta Llama 3.1 70B",
      "labelOpenRouter": "Meta: Llama 3.1 70B",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q4 2025",
      "descriptionShort": "Efficient conversational model optimized for responsive multilingual chatbot interactions.",
      "descriptionMedium": "Llama 3.1 70B provides efficient multilingual conversational support ideal for applications where responsiveness and computational efficiency are critical. Effective for building chatbots, automated customer interactions, and applications needing fast yet reliable language understanding.",
      "launchDate": "2024-07-23T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": false,
      "structuredOutputBackend": "guidance",
      "maximumLoRArank": 16,
      "parameterCountTotal": 70000000000,
      "contextWindow": 131072,
      "priceCentsPerBillionTokensInput": 80000,
      "priceCentsPerBillionTokensCached": 80000,
      "priceCentsPerBillionTokensOutput": 80000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_meta-llama_Llama-3.3-70B-Instruct"],
      "likesHuggingFace": 1025,
      "downloadsHuggingFace": 95027,
      "license": "llama3.1"
    },
    {
      "provider": "coreweave",
      "id": "cw_meta-llama_Llama-3.1-8B-Instruct",
      "idPlayground": "meta-llama/Llama-3.1-8B-Instruct",
      "idHuggingFace": "meta-llama/Llama-3.1-8B-Instruct",
      "openRouterPermaslug": "meta-llama/llama-3.1-8b-instruct",
      "label": "Meta Llama 3.1 8B",
      "labelOpenRouter": "Meta: Llama 3.1 8B",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2025",
      "descriptionShort": "Efficient conversational model optimized for responsive multilingual chatbot interactions.",
      "descriptionMedium": "Llama 3.1 8B provides efficient multilingual conversational support ideal for applications where responsiveness and computational efficiency are critical. Effective for building chatbots, automated customer interactions, and applications needing fast yet reliable language understanding.",
      "launchDate": "2024-07-01T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": true,
      "featureTrainableServerlessRL": true,
      "structuredOutputBackend": "guidance",
      "maximumLoRArank": 16,
      "parameterCountTotal": 8000000000,
      "contextWindow": 131072,
      "priceCentsPerBillionTokensInput": 22000,
      "priceCentsPerBillionTokensCached": 22000,
      "priceCentsPerBillionTokensOutput": 22000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 8779,
      "downloadsHuggingFace": 4475436,
      "license": "llama3.1"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-V4-Pro-0813",
      "idPlayground": "deepseek-ai/DeepSeek-V4-Pro-0813",
      "idHuggingFace": "deepseek-ai/DeepSeek-V4-Pro-0813",
      "openRouterPermaslug": "deepseek/deepseek-v4-pro-20260813",
      "label": "DeepSeek V4-Pro-0813",
      "labelOpenRouter": "DeepSeek: DeepSeek V4 Pro 0813",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "DeepSeek V4-Pro-0813 is a 1.6T-parameter MoE model excelling at advanced reasoning, coding, and complex agentic workloads.",
      "descriptionMedium": "DeepSeek V4-Pro-0813 is a 1.6T-parameter MoE model with 49B active parameters. It is the official release of DeepSeek V4-Pro purpose-built for advanced reasoning, complex software engineering, and long-horizon agentic tasks.",
      "launchDate": "2026-08-13T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 1600000000000,
      "parameterCountActive": 49000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 131000,
      "priceCentsPerBillionTokensCached": 4400,
      "priceCentsPerBillionTokensOutput": 396000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 909,
      "downloadsHuggingFace": 151847,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-V4-Flash-0731",
      "idPlayground": "deepseek-ai/DeepSeek-V4-Flash-0731",
      "idHuggingFace": "deepseek-ai/DeepSeek-V4-Flash-0731",
      "openRouterPermaslug": "deepseek/deepseek-v4-flash-20260731",
      "label": "DeepSeek V4-Flash-0731",
      "labelOpenRouter": "DeepSeek: DeepSeek V4 Flash 0731",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod", "cw-qa"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "DeepSeek V4-Flash-0731 is an MoE model great for coding, reasoning, and agentic workloads.",
      "descriptionMedium": "DeepSeek V4-Flash-0731 is an updated MoE model from the original DeepSeek V4-Flash release. Its smaller size in the DeepSeek V4 family makes it ideal for fast and efficient coding, reasoning, and agentic workloads.",
      "launchDate": "2026-07-31T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 284000000000,
      "parameterCountActive": 13000000000,
      "contextWindow": 262144,
      "priceCentsPerBillionTokensInput": 13000,
      "priceCentsPerBillionTokensCached": 5000,
      "priceCentsPerBillionTokensOutput": 27000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 4095,
      "downloadsHuggingFace": 2984962,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-V4-Pro",
      "idPlayground": "deepseek-ai/DeepSeek-V4-Pro",
      "idHuggingFace": "deepseek-ai/DeepSeek-V4-Pro",
      "openRouterPermaslug": "deepseek/deepseek-v4-pro-20260423",
      "label": "DeepSeek V4-Pro",
      "labelOpenRouter": "DeepSeek: DeepSeek V4 Pro",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "DeepSeek V4-Pro is a 1.6T-parameter MoE model with 49B active parameters excelling at advanced reasoning, coding, and complex agentic workloads.",
      "descriptionMedium": "DeepSeek V4-Pro is a 1.6T-parameter MoE model with 49B active parameters and a 1M context length. As the flagship of the DeepSeek V4 family, it features a hybrid attention architecture for efficient long-context processing and is purpose-built for advanced reasoning, complex software engineering, and long-horizon agentic tasks.",
      "launchDate": "2026-04-24T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-off",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 1600000000000,
      "parameterCountActive": 49000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 115000,
      "priceCentsPerBillionTokensCached": 20000,
      "priceCentsPerBillionTokensOutput": 255000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_deepseek-ai_DeepSeek-V4-Pro-0813"],
      "likesHuggingFace": 5695,
      "downloadsHuggingFace": 353642,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-V4.1-Flash-1017",
      "idPlayground": "deepseek-ai/DeepSeek-V4.1-Flash-1017",
      "idHuggingFace": "deepseek-ai/DeepSeek-V4.1-Flash-1017",
      "openRouterPermaslug": "deepseek/deepseek-v4.1-flash-20261017",
      "label": "DeepSeek V4.1-Flash-1017",
      "labelOpenRouter": "DeepSeek: DeepSeek V4.1 Flash 1017",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q4 2026",
      "descriptionShort": "DeepSeek V4.1 Flash 1017 is a multimodal MoE model for coding, reasoning, and faster agentic workflows with 1M context.",
      "descriptionMedium": "DeepSeek V4.1 Flash 1017 is an updated multimodal Mixture-of-Experts model with a 1M-token context window. It accepts text and image inputs and improves reasoning, coding, agentic tasks, and visual understanding over DeepSeek V4.1 Flash while reducing task execution time and output length. Its architecture activates 8B parameters during prefill and 16B during decoding.",
      "launchDate": "2026-10-17T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "_reasoningEfforts": "Accepts an int in [1, 100] or one of low/high/max (mapped to 50/75/100) Ref: https://huggingface.co/deepseek-ai/DeepSeek-V4.1-Flash-1017/blob/main/encoding/encoding.py",
      "reasoningEfforts": [
        "low",
        "high",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 763000000000,
      "parameterCountActive": 16000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 30000,
      "priceCentsPerBillionTokensCached": 600,
      "priceCentsPerBillionTokensOutput": 120000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 4864,
      "downloadsHuggingFace": 187260,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-V4.1-Flash",
      "idPlayground": "deepseek-ai/DeepSeek-V4.1-Flash",
      "idHuggingFace": "deepseek-ai/DeepSeek-V4.1-Flash",
      "openRouterPermaslug": "deepseek/deepseek-v4.1-flash-20260910",
      "label": "DeepSeek V4.1-Flash",
      "labelOpenRouter": "DeepSeek: DeepSeek V4.1 Flash",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2026",
      "descriptionShort": "DeepSeek V4.1 Flash is a multimodal MoE model for coding, reasoning, and agentic workloads with long contexts.",
      "descriptionMedium": "DeepSeek V4.1 Flash is a multimodal Mixture-of-Experts model supporting text and image inputs. It supports coding, reasoning, and agentic tasks with long context.",
      "launchDate": "2026-09-10T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "_reasoningEfforts": "Chat template rejects 'minimal' and 'medium'; accepts none, low, high, xhigh, max, or an integer 1-100.",
      "reasoningEfforts": [
        "none",
        "low",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 552000000000,
      "parameterCountActive": 16000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 13000,
      "priceCentsPerBillionTokensCached": 200,
      "priceCentsPerBillionTokensOutput": 65000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 4858,
      "downloadsHuggingFace": 2112607,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-V4-Flash",
      "idPlayground": "deepseek-ai/DeepSeek-V4-Flash",
      "idHuggingFace": "deepseek-ai/DeepSeek-V4-Flash",
      "openRouterPermaslug": "deepseek/deepseek-v4-flash-20260423",
      "label": "DeepSeek V4-Flash",
      "labelOpenRouter": "DeepSeek: DeepSeek V4 Flash",
      "status": "hosted",
      "lifecycleStage": "retired",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2026",
      "descriptionShort": "DeepSeek V4-Flash is an MoE model with 1M context length great for coding, reasoning, and agentic workloads.",
      "descriptionMedium": "DeepSeek V4-Flash is an MoE model with 1M context length. Its smaller size in the DeepSeek V4 family makes it ideal for fast and efficient coding, reasoning, and agentic workloads.",
      "launchDate": "2026-04-24T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-off",
      "reasoningEfforts": [
        "none",
        "minimal",
        "low",
        "medium",
        "high",
        "xhigh",
        "max"
      ],
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 284000000000,
      "parameterCountActive": 13000000000,
      "contextWindow": 1048576,
      "priceCentsPerBillionTokensInput": 14000,
      "priceCentsPerBillionTokensCached": 7000,
      "priceCentsPerBillionTokensOutput": 28000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "dateDeprecated": "2026-09-04T09:00:00Z",
      "dateRetired": "2026-10-05T09:00:00Z",
      "recommendedReplacement": ["cw_deepseek-ai_DeepSeek-V4-Flash-0731"],
      "likesHuggingFace": 2367,
      "downloadsHuggingFace": 1080069,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-V3.1",
      "idPlayground": "deepseek-ai/DeepSeek-V3.1",
      "idHuggingFace": "deepseek-ai/DeepSeek-V3.1",
      "openRouterPermaslug": "deepseek/deepseek-chat-v3.1",
      "label": "DeepSeek V3.1",
      "labelOpenRouter": "DeepSeek: DeepSeek V3.1",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q3 2025",
      "descriptionShort": "A large hybrid model that supports both thinking and non-thinking modes via prompt templates.",
      "descriptionMedium": "DeepSeek-V3.1 is a large hybrid reasoning model (671B parameters, 37B active) that supports both thinking and non-thinking modes via prompt templates. It extends the DeepSeek-V3 base with a two-phase long-context training process, reaching up to 128K tokens, and uses FP8 microscaling for efficient inference. The model improves code generation, and reasoning efficiency, achieving performance comparable to DeepSeek R1-0528 on difficult benchmarks while responding more quickly. It is suitable for research, coding, and agentic workflows. It succeeds the DeepSeek V3-0324 model and performs well on a variety of tasks.",
      "launchDate": "2025-08-21T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 671000000000,
      "parameterCountActive": 37000000000,
      "contextWindow": 161000,
      "priceCentsPerBillionTokensInput": 55000,
      "priceCentsPerBillionTokensCached": 55000,
      "priceCentsPerBillionTokensOutput": 165000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 864,
      "downloadsHuggingFace": 268596,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-R1-0528",
      "idPlayground": "deepseek-ai/DeepSeek-R1-0528",
      "idHuggingFace": "deepseek-ai/DeepSeek-R1-0528",
      "label": "DeepSeek R1-0528",
      "labelOpenRouter": "DeepSeek: R1-0528",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-02-18T09:00:00Z",
      "dateRetired": "2026-03-04T09:00:00Z",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2025",
      "descriptionShort": "Optimized for precise reasoning tasks including complex coding, math, and structured document analysis.",
      "descriptionMedium": "DeepSeek R1-0528 specializes in tasks requiring detailed reasoning, including mathematics, programming, and logical problem-solving. It's particularly effective in scenarios like complex coding tasks, planning workflows, and analyzing structured documents with enhanced accuracy and reduced hallucinations.",
      "launchDate": "2025-05-28T09:00:00Z",
      "featureReasoning": true,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "reasoningSupport": "default-on",
      "reasoningArgument": "enable_thinking",
      "parameterCountTotal": 680000000000,
      "parameterCountActive": 37000000000,
      "contextWindow": 161000,
      "priceCentsPerBillionTokensInput": 135000,
      "priceCentsPerBillionTokensCached": 135000,
      "priceCentsPerBillionTokensOutput": 540000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 2494,
      "downloadsHuggingFace": 109795,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_deepseek-ai_DeepSeek-V3-0324",
      "idPlayground": "deepseek-ai/DeepSeek-V3-0324",
      "idHuggingFace": "deepseek-ai/DeepSeek-V3-0324",
      "label": "DeepSeek V3-0324",
      "labelOpenRouter": "Deepseek: V3-0324",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-02-18T09:00:00Z",
      "dateRetired": "2026-03-04T09:00:00Z",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2025",
      "descriptionShort": "Robust Mixture-of-Experts model tailored for high-complexity language processing and comprehensive document analysis.",
      "descriptionMedium": "DeepSeek V3-0324 is a powerful Mixture-of-Experts model designed for demanding language tasks, including comprehensive information extraction, content summarization, document analysis, and handling complex, structured textual data. It excels in balancing depth and accuracy in high-complexity scenarios.",
      "launchDate": "2025-03-24T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 680000000000,
      "parameterCountActive": 37000000000,
      "contextWindow": 161000,
      "priceCentsPerBillionTokensInput": 114000,
      "priceCentsPerBillionTokensCached": 114000,
      "priceCentsPerBillionTokensOutput": 275000,
      "quantization": "fp8",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 3223,
      "downloadsHuggingFace": 225055,
      "license": "mit"
    },
    {
      "provider": "coreweave",
      "id": "cw_meta-llama_Llama-3.3-70B-Instruct",
      "idPlayground": "meta-llama/Llama-3.3-70B-Instruct",
      "idHuggingFace": "meta-llama/Llama-3.3-70B-Instruct",
      "openRouterPermaslug": "meta-llama/llama-3.3-70b-instruct",
      "label": "Meta Llama 3.3 70B",
      "labelOpenRouter": "Meta: Llama 3.3 70B",
      "status": "hosted",
      "lifecycleStage": "general-availability",
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2025",
      "descriptionShort": "Multilingual model excelling in conversational tasks, detailed instruction-following, and coding.",
      "descriptionMedium": "Llama 3.3 70B excels in multilingual conversational interactions, providing strong capabilities in detailed instruction-following, coding tasks, and mathematical reasoning. Ideal for general-purpose chatbots, complex text-based queries, and multilingual user interactions.",
      "launchDate": "2024-12-01T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 70000000000,
      "contextWindow": 128000,
      "priceCentsPerBillionTokensInput": 71000,
      "priceCentsPerBillionTokensCached": 71000,
      "priceCentsPerBillionTokensOutput": 71000,
      "quantization": "fp16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 3185,
      "downloadsHuggingFace": 363283,
      "license": "llama3.3"
    },
    {
      "provider": "coreweave",
      "id": "cw_meta-llama_Llama-4-Scout-17B-16E-Instruct",
      "idPlayground": "meta-llama/Llama-4-Scout-17B-16E-Instruct",
      "idHuggingFace": "meta-llama/Llama-4-Scout-17B-16E-Instruct",
      "label": "Meta Llama 4 Scout",
      "labelOpenRouter": "Meta: Llama 4 Scout",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-04-07T09:00:00Z",
      "dateRetired": "2026-04-21T09:00:00Z",
      "recommendedReplacement": ["cw_Qwen_Qwen3.5-35B-A3B"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2025",
      "descriptionShort": "Multimodal model integrating text and image understanding, ideal for visual tasks and combined analysis.",
      "descriptionMedium": "Llama 4 Scout integrates text and image understanding, making it suitable for multimodal applications such as visual Q&A, content moderation, captioning, and analysis tasks involving images combined with textual data. It efficiently balances computational load via a mixture-of-experts architecture.",
      "launchDate": "2025-04-01T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 109000000000,
      "parameterCountActive": 17000000000,
      "contextWindow": 64000,
      "priceCentsPerBillionTokensInput": 17000,
      "priceCentsPerBillionTokensCached": 17000,
      "priceCentsPerBillionTokensOutput": 66000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text", "Vision"],
      "modalitiesInput": ["text", "image"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 1385,
      "downloadsHuggingFace": 108045,
      "license": "other"
    },
    {
      "provider": "coreweave",
      "id": "cw_microsoft_Phi-4-mini-instruct",
      "idPlayground": "microsoft/Phi-4-mini-instruct",
      "idHuggingFace": "microsoft/Phi-4-mini-instruct",
      "openRouterPermaslug": "microsoft/phi-4-mini-instruct",
      "label": "Microsoft Phi 4 Mini 3.8B",
      "labelOpenRouter": "Microsoft: Phi 4 Mini 3.8B",
      "status": "hosted",
      "lifecycleStage": "retired",
      "dateDeprecated": "2026-06-30T09:00:00Z",
      "dateRetired": "2026-08-04T09:00:00Z",
      "recommendedReplacement": ["cw_JetBrains_Mellum2-12B-A2.5B-Instruct"],
      "availableIn": ["cw-prod"],
      "launchedQuarter": "Q2 2025",
      "descriptionShort": "Compact, efficient model ideal for fast responses in resource-constrained environments.",
      "descriptionMedium": "Phi 4 Mini is optimized for use in lightweight environments, excelling at quick interactions, and constrained-resource deployments. It supports strong mathematical and logical inference, suitable for embedded applications, mobile environments, or real-time AI assistants.",
      "launchDate": "2025-02-01T09:00:00Z",
      "featureReasoning": false,
      "featureJsonMode": true,
      "featureStructuredOutput": true,
      "featureToolCalling": true,
      "featureLoRA": false,
      "featureTrainableServerlessRL": false,
      "parameterCountTotal": 3800000000,
      "contextWindow": 128000,
      "priceCentsPerBillionTokensInput": 8000,
      "priceCentsPerBillionTokensCached": 8000,
      "priceCentsPerBillionTokensOutput": 35000,
      "quantization": "bf16",
      "isAvailableOpenRouter": true,
      "apiStyle": "chat",
      "modalities": ["Text"],
      "modalitiesInput": ["text"],
      "modalitiesOutput": ["text"],
      "tags": [],
      "likesHuggingFace": 879,
      "downloadsHuggingFace": 343554,
      "license": "mit"
    }
  ]
}
